var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"fill-height",staticStyle:{"min-height":"500px"},attrs:{"fluid":"","pa-0":""}},[_c('v-img',{attrs:{"src":require("@/assets/landingAbout.png")}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }